export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_19.fb91e9ab.jpg";